import { render, staticRenderFns } from "./blackExport.vue?vue&type=template&id=5b0abd12&scoped=true&"
import script from "./blackExport.vue?vue&type=script&lang=js&"
export * from "./blackExport.vue?vue&type=script&lang=js&"
import style0 from "./blackExport.vue?vue&type=style&index=0&id=5b0abd12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0abd12",
  null
  
)

export default component.exports